import { z } from "zod";

import { apiGet } from "../lib/api";

export const LatencyStatSchema = z.object({
  stage: z.string(),
  p50_ms: z.number(),
  p95_ms: z.number(),
  samples: z.number(),
});
export type LatencyStat = z.infer<typeof LatencyStatSchema>;

export const TokensByModelSchema = z.object({
  model: z.string(),
  tokens: z.number(),
});
export type TokensByModel = z.infer<typeof TokensByModelSchema>;

export const TopEngagementSchema = z.object({
  engagement_id: z.string().uuid(),
  display_name: z.string().nullable().optional(),
  turns: z.number(),
});
export type TopEngagement = z.infer<typeof TopEngagementSchema>;

export const VolumeBucketSchema = z.object({
  hour_start: z.string(),
  turns: z.number(),
});
export type VolumeBucket = z.infer<typeof VolumeBucketSchema>;

export const RecordingCountersSchema = z.object({
  started: z.number().default(0),
  stopped: z.number().default(0),
  failed: z.number().default(0),
  accessed: z.number().default(0),
});
export type RecordingCounters = z.infer<typeof RecordingCountersSchema>;

export const TelemetryOverviewSchema = z.object({
  window_hours: z.number(),
  calls_count: z.number(),
  turns_count: z.number(),
  error_rate: z.number(),
  tokens_total: z.number(),
  latencies: z.array(LatencyStatSchema),
  recording: RecordingCountersSchema,
  tokens_by_model: z.array(TokensByModelSchema),
  top_engagements: z.array(TopEngagementSchema),
  volume: z.array(VolumeBucketSchema),
});
export type TelemetryOverview = z.infer<typeof TelemetryOverviewSchema>;

export function fetchTelemetry(windowHours: number = 24) {
  return apiGet(`/api/telemetry?window_hours=${windowHours}`, TelemetryOverviewSchema);
}
